var _path, _path2, _path3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgWidgetMyWallet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 36 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1114 12.5054C31.0218 12.4999 30.9242 12.5 30.823 12.5L30.7977 12.5H26.8296C23.5588 12.5 20.7601 14.9999 20.7601 18.26C20.7601 21.5201 23.5588 24.02 26.8296 24.02H30.7977L30.823 24.02C30.9242 24.02 31.0218 24.0201 31.1114 24.0146C32.44 23.9331 33.6149 22.9236 33.7137 21.5136C33.7202 21.4211 33.7201 21.3214 33.7201 21.2291L33.7201 21.204V15.316L33.7201 15.2909C33.7201 15.1986 33.7202 15.0989 33.7137 15.0064C33.6149 13.5964 32.44 12.5869 31.1114 12.5054ZM26.4777 19.796C27.3198 19.796 28.0024 19.1083 28.0024 18.26C28.0024 17.4117 27.3198 16.724 26.4777 16.724C25.6357 16.724 24.953 17.4117 24.953 18.26C24.953 19.1083 25.6357 19.796 26.4777 19.796Z",
    fill: "url(#paint0_linear_5994_1080)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0407 12.5021C31.0407 10.802 30.9788 8.97837 29.8921 7.671C29.7872 7.5448 29.6755 7.42225 29.5565 7.30332C28.4789 6.22567 27.1124 5.74743 25.4241 5.52044C23.7836 5.29989 21.6876 5.29991 19.0412 5.29993H15.9987C13.3523 5.29991 11.2562 5.29989 9.61573 5.52044C7.92744 5.74743 6.56095 6.22568 5.48331 7.30332C4.40567 8.38096 3.92742 9.74745 3.70043 11.4357C3.47988 13.0762 3.4799 15.1723 3.47992 17.8187V17.9812C3.4799 20.6275 3.47988 22.7237 3.70044 24.3641C3.92742 26.0524 4.40567 27.4189 5.48331 28.4965C6.56095 29.5742 7.92744 30.0524 9.61573 30.2794C11.2562 30.5 13.3523 30.4999 15.9986 30.4999H19.0412C21.6875 30.4999 23.7837 30.5 25.4241 30.2794C27.1124 30.0524 28.4789 29.5742 29.5565 28.4965C29.851 28.202 30.1011 27.8854 30.3137 27.5459C30.9624 26.5098 31.0407 25.2401 31.0407 24.0177C30.9712 24.02 30.8981 24.0199 30.8229 24.0199L26.8294 24.0199C23.5586 24.0199 20.7599 21.52 20.7599 18.2599C20.7599 14.9999 23.5586 12.4999 26.8294 12.4999L30.8228 12.4999C30.898 12.4999 30.9712 12.4999 31.0407 12.5021Z",
    fill: "url(#paint1_linear_5994_1080)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88003 11.0597C8.28357 11.0597 7.80003 11.5432 7.80003 12.1397C7.80003 12.7362 8.28357 13.2197 8.88003 13.2197H14.64C15.2365 13.2197 15.72 12.7362 15.72 12.1397C15.72 11.5432 15.2365 11.0597 14.64 11.0597H8.88003Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_5994_1080)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.0016 36.1389C22.3465 36.1389 25.8686 36.608 25.8686 37.1867C25.8686 37.7654 22.3465 38.2345 18.0016 38.2345C13.6568 38.2345 10.1347 37.7654 10.1347 37.1867C10.1347 36.608 13.6568 36.1389 18.0016 36.1389Z",
    fill: "#261300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5994_1080",
    x: 9.28359,
    y: 34.7235,
    width: 17.4335,
    height: 4.92651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375,
    result: "effect1_foregroundBlur_5994_1080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5994_1080",
    x1: 20.7601,
    y1: 12.5,
    x2: 32.2006,
    y2: 25.3706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#6CE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#28B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0A54C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5994_1080",
    x1: 3.47992,
    y1: 5.29993,
    x2: 28.5792,
    y2: 32.7505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.055,
    stopColor: "#6CE5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#28B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0A54C4"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWidgetMyWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/WidgetMyWallet.f848c9e3.svg";
export { ForwardRef as ReactComponent };